"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTemplate = void 0;
var SessionTemplate_component_1 = require("./SessionTemplate.component");
Object.defineProperty(exports, "SessionTemplate", { enumerable: true, get: function () { return __importDefault(SessionTemplate_component_1).default; } });
